import { CommentOutlined, ThumbsUpDownOutlined, VisibilityOutlined } from '@mui/icons-material'
import { Avatar, Box, Button, Card, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { CHIP_COLORS, getTimePassedFrom, Icons } from '../../utils/utilities'
import { useDiscussionForum } from '../../store/discussionforum.store'
import noDiscussionsImg from '../../assets/no-discussions.svg'
import { useUserStore } from '../../store/user.store'
import DataLoadingSpinner from '../common/DataLoadingSpinner'
import { observer } from 'mobx-react'
import dayjs from 'dayjs'

const DiscussionsCard = observer( () => {

    const [loading, setLoading] = useState( true )
    const [error, setError] = useState( null )

    const { layout, border, palette } = useTheme()

    const DiscussionForumStore = useDiscussionForum()
    const UserStore = useUserStore()

    const getData = useCallback( async () => {
        if ( DiscussionForumStore.getErrors.discussions === true ) {
            const { success, message, code } = await DiscussionForumStore.fetchDiscussions( {} )
            if ( !success ) {
                setError( { message, code } )
            } else {
                setError( null )
            }
        }
        setLoading( false )
    }, [DiscussionForumStore] )

    useEffect( () => {
        getData()
    }, [getData] )

    return (
        <Box gridArea="dc" minHeight="400px" display="flex" flexDirection="column">
            <Box marginBottom="5px" height="25px" display="flex" gap="10px" alignItems="center">
                <Link className='default-link' to={UserStore.getUser["user_role"] === "STUDENT" ? `/student/discussions` : `/faculty/discussions`}>
                    <Typography sx={{ ":hover .redirect-arrow": { transform: "translate(2px,-2px)", color: "primary.main" } }} display="flex" gap="5px" alignItems="center" variant='subtitle2' component="h3" flexGrow={1}>
                        <Typography component="span" display="flex" alignItems="center" color='primary'>{Icons.default.DiscussionsOutlined}</Typography>
                        Recent Discussions
                        <Typography component="span" color='textSecondary' className='redirect-arrow' display="flex" alignItems="center">{Icons.default.ArrowOutward}</Typography>

                    </Typography>
                </Link>
                {/* <Button size="small" sx={{ fontSize: "12px", borderRadius: "20px", padding: "1px 5px" }} variant='contained' color='customThemeColor' disableElevation>
                        View all
                    </Button> */}
            </Box>
            <Card elevation={0} className='slim-custom-scrollbar' sx={{ flexGrow: 1, border: border[1] }}>
                {DiscussionForumStore.getDiscussions.length > 0 && <Box gap="5px" padding="10px" width="100%" flexGrow={1} display="flex" flexDirection="column" overflow="auto">
                    {DiscussionForumStore.getDiscussions
                        .filter( d => dayjs( d.created_at ).add( 30, 'days' ) > dayjs() )
                        .slice( 0, 3 )
                        .map( ( discussion, index ) => {
                            return (
                                <Link key={discussion._id} className='default-link' to={UserStore.getUser.user_role === "STUDENT" ? `/student/discussion/${discussion._id}` : `/faculty/discussion/${discussion._id}`}>
                                    <Box sx={{ ":hover": { background: palette.rowHover } }} border={border[1]} borderRadius={layout.borderRadius} padding="10px" >
                                        <Box display="flex" alignItems="center" justifyContent="space-between">
                                            <Box display="flex" alignItems="center" gap="10px">
                                                <Avatar sx={{ width: "32px", height: "32px", background: CHIP_COLORS[( discussion.creator_data.name?.length || 0 ) % CHIP_COLORS.length] }}>
                                                    {Array.from( discussion.creator_data.name ).at( 0 )}
                                                </Avatar>
                                                <Box>
                                                    <Typography fontSize="12px" fontWeight="400" >@{discussion.creator_data.name}</Typography>
                                                    <Typography fontSize="10px" color='textSecondary' fontWeight="300" >{discussion.created_by}</Typography>
                                                </Box>
                                            </Box>
                                            <Typography fontSize="12px" fontWeight="300" >{getTimePassedFrom( discussion.created_at )}</Typography>
                                        </Box>
                                        <Typography marginTop="5px" variant='h6' component="p" fontWeight="500" fontSize="14px" lineHeight="20px">{discussion.title}</Typography>
                                        <Box display="flex" flexWrap="wrap" gap="5px" alignItems="center">
                                            {discussion.categories.map( ( category, index ) => {
                                                return (
                                                    <Typography key={category} color='textSecondary' fontSize="10px">#{category}</Typography>
                                                )
                                            } )}
                                        </Box>
                                        <Box marginTop="10px" display="flex" gap="10px" alignItems="center">
                                            <Tooltip title="Views">
                                                <Typography display="flex" gap="5px" alignItems="center" variant="subtitle2">{discussion.views} <VisibilityOutlined sx={{ fontSize: "15px" }} /></Typography>
                                            </Tooltip>
                                            <Tooltip title="Votes">
                                                <Typography display="flex" gap="5px" alignItems="center" variant="subtitle2">{discussion.votes.up - discussion.votes.down} <ThumbsUpDownOutlined sx={{ fontSize: "15px" }} /></Typography>
                                            </Tooltip>
                                            <Tooltip title="Comments" >
                                                <Typography display="flex" gap="5px" alignItems="center" variant="subtitle2">{discussion.comment_count} <CommentOutlined sx={{ fontSize: "15px" }} /> </Typography>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                </Link>
                            )
                        } )}
                </Box>}
                {!loading && DiscussionForumStore.getDiscussions.filter( d => dayjs( d.created_at ).add( 30, 'days' ) > dayjs() ).length === 0 && <Box padding="20px" display="flex" alignItems="center" justifyContent="center" flexGrow={1} flexDirection="column" height="100%" gap="10px">
                    <Box component="img" width="150px" src={noDiscussionsImg} alt="No discussions" />
                    <Typography variant='subtitle2' >No recent discussions</Typography>

                </Box>}
                {loading && <Box display="flex" alignItems="center" justifyContent="center" flexGrow={1}>
                    <DataLoadingSpinner />
                </Box>}
            </Card>
        </Box>
    )
} )

export default DiscussionsCard
